import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';
import { SearchService } from 'app/services/search/search.service';

@Component({
  selector: 'app-agences-djerba',
  templateUrl: './agences-djerba.component.html',
  styleUrls: ['./agences-djerba.component.scss']
})
export class AgencesDjerbaComponent implements OnInit {

  @ViewChild('agencyForm', { static: false })
  closeResult = '';
  search_name1:any;
  public search: string  = ''
  agencyForm: NgForm;
  p: Number = 1;
  lengthSociete=10
  totalSociete : any

  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  public Agency: any

  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  Agenciesdjerba:any

  constructor(private agenciesService: AgenciesService,
    private primengConfig: PrimeNGConfig ,
    private searchService: SearchService ) { }

  ngOnInit() {
 
    this.getagencesBizerte();

  }
  getagencesBizerte() {
    this.agenciesService.getListAgenceDjerba().subscribe((data: any) => {
      this.Agenciesdjerba = data;
      console.log("liste des promteurs à djerba", this.Agenciesdjerba);
      // Filtrer les promoteurs de djerba
      this.agencies = this.Agenciesdjerba.filter((agencie: any) => {
        return agencie.region === 'Bizerte'; 
        this.performSearch(); // Filtre uniquement les promoteurs ayant la région "Bizerte"
      });
        
    });
  }
  




  cancelEdit() {
    this.isEditMode = false;
    this.agencyForm.resetForm();
  }

  deleteAgencies(agencie: any) {
    this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {

      console.log(this.dataSource.data);

    });
  
    
  }

 public changePage(){
  this.lengthSociete=this.lengthSociete+10;
}


  
performSearch() {
  this.Agenciesdjerba = this.searchService.search(this.Agenciesdjerba, this.search);
}
}